<template>
  <vue-custom-scrollbar
    class="chat-history line-chat foo3 touch_css"
    id="chat-history"
    :settings="settings"
    @ps-scroll-y="scrollHanle"
    v-chat-scroll
    @scroll-top="loadNewData"
  >
    <ul>
      <ChatMessage v-for="(message, index) in ChatHistory" :index="index" :key="index" :data="message"></ChatMessage>
    </ul>
  </vue-custom-scrollbar>
</template>
  <script>
import ChatMessage from "../Main/ChatMessage.vue";
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import Global from "@/components/Global";
import { ChatLogHandler } from "@/handler/ChatLogHandler.js";
import store_sticker from "@/vuex/store_sticker.js";

function scrollBottom() {
  if (this.lazyload.status === true) {
    this.lazyload.status = false;

    $("#chat-history").animate(
      {
        scrollTop: $("#comment").offset().top
      },
      10
    );

    return false;
  }

  $("#chat-history").animate(
    {
      scrollTop: this.$el.scrollHeight
    },
    10
  );
}

// 聊天室功能列
export default {
  name: "ChatToolBar",
  props: ["messages"],
  components: { ChatMessage },
  created() {},
  data() {
    return {
      showTypingIndicator: false,
      fullscreenLoading: false,
      lazyload: {
        status: false,
        scrollbarHeigth: "",
        fullscreenLoading: false
      },
      settings: {
        maxScrollbarLength: 60
      }
    };
  },
  methods: {
    //scroll top 載入舊訊息
    loadNewData: function() {
      this.lazyload.fullscreenLoading = true;
      var messages_ = ChatLogHandler.GetHistory(this.ChatHistory.length);
      for (var i = 0; i < messages_.length; i++) {
        this.messages.unshift({
          frmId: messages_[i].frmId,
          UserName: messages_[i].UserName,
          Text: messages_[i].Text,
          msgTime: this.convertUTCDateToLocalDate(messages_[i].msgTime),
          msgType: messages_[i].msgType,
          filePath: messages_[i].filePath,
          previewImageUrl: messages_[i].previewImageUrl,
          senderType: messages_[i].senderType,
          UserPicture: messages_[i].UserPicture
        });
      }
      this.lazyload.status = true;
      this.lazyload.fullscreenLoading = false;
    },
    stickerPackagesVisible: function() {
      return store_sticker.state.stickerPackagesVisible;
    },
    scrollHanle(evt) {}
  },
  computed: {
    ChatHistory: function() {
      this.$nextTick(scrollBottom);
      return this.messages;
    }
  }
};
</script>
 <style>
.touch_css {
  -webkit-overflow-scrolling: touch;
}
.showStickerClass {
  height: calc(50% - 187px) !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Main/ChatLog.vue